import { css } from '@/styled-system/css';

export const chatBubbleStyles = css.raw({
  borderRadius: '500',
  whiteSpace: 'pre-wrap',
  width: 'fit-content',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 396px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  maxWidth: '396px',
  padding: '{spacing.tight} {spacing.default}',
  marginBottom: 'tighter',
  position: 'relative',
});

export const autoResponseChatBubbleStyles = css.raw({
  borderBottomLeftRadius: '100',
  backgroundColor: 'bg.neutral',
  border: '1px solid',
  borderColor: 'border.muted',
});

export const messageOwnerChatBubbleStyles = css.raw({
  borderBottomRightRadius: '100',
  backgroundColor: 'bg.accent.blue.hero',
  float: 'right',
});

export const defaultChatBubbleStyles = css.raw({
  backgroundColor: 'bg.softest',
  borderBottomLeftRadius: '100',
});
